import { LegalPageLayout } from '@/components/legal-page-layout'
import { Link } from '@/components/link'

export default function LegalTerms() {
  return (
    <LegalPageLayout title="Terms of Service" lastUpdated="October 4, 2024">
      <section className="mb-6">
        <h2 className="mb-2 text-xl">1. Introduction</h2>
        <p>
          Welcome to Git Digest! These Terms of Service (&quot;Terms&quot;) govern your use of our services. When we say
          &quot;Company&quot;, &quot;we&quot;, &quot;our&quot;, or &quot;us&quot; in this document, we are referring to,
          Sunergos IT LLC, the company behind Git Digest. When we say &quot;Service&quot;, we are referring to Git
          Digest. When we say &quot;You&quot; or &quot;your&quot;, we are referring to the people or organizations that
          own an account with our Service.
        </p>
        <p className="mt-2">
          By accessing or using Git Digest, you agree to be bound by these Terms. The Service is only available to you
          if you have entered the age of majority in your jurisdiction of residence and are fully able and competent to
          enter into, abide by and comply with the Terms.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="mb-2 text-xl">2. Account Terms</h2>
        <ul className="list-inside list-disc space-y-2">
          <li>
            You are responsible for maintaining the security of your account and password. The Company cannot and will
            not be liable for any loss or damage from your failure to comply with this security obligation.
          </li>
          <li>You must provide accurate and complete information when creating an account.</li>
          <li>You are responsible for all content posted and activity that occurs under your account.</li>
          <li>
            You must be a human. Accounts registered by &quot;bots&quot; or other automated methods are not permitted.
          </li>
        </ul>
      </section>

      <section className="mb-6">
        <h2 className="mb-2 text-xl">3. Payment, Refunds, and Plan Changes</h2>
        <p>
          For paid services, payment must be made in advance. If payment is not received, we may freeze your account
          until payment is made. All fees are exclusive of taxes, which we will collect where required. For more
          information on taxes, please refer to our{' '}
          <Link href="/taxes" className="decoration-golden-500 hover:text-golden-500 underline">
            Taxes page
          </Link>
          . Refunds are processed according to our{' '}
          <Link href="/refund" className="decoration-golden-500 hover:text-golden-500 underline">
            Fair Refund policy
          </Link>
          .
        </p>
      </section>

      <section className="mb-6">
        <h2 className="mb-2 text-xl">4. Cancellation and Termination</h2>
        <p>
          You are responsible for properly canceling your account. Upon cancellation, all of your content will be
          immediately deleted. We reserve the right to suspend or terminate your account for any reason, at any time.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="mb-2 text-xl">5. Modifications to the Service and Prices</h2>
        <p>
          We reserve the right to modify or discontinue any part of the Service. Prices are subject to change upon 30
          days notice. We shall not be liable for any modification, price change, suspension, or discontinuance of the
          Service.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="mb-2 text-xl">6. Copyright and Content Ownership</h2>
        <p>
          The content you provide remains yours. We claim no intellectual property rights over your material. However,
          the look and feel of the Service is copyright© Git Digest. All rights reserved.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="mb-2 text-xl">7. Features and Bugs</h2>
        <p>
          We make no guarantees that our Service will meet your specific requirements or be error-free. We work to fix
          priority bugs but cannot guarantee all reported bugs will be fixed.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="mb-2 text-xl">8. Liability</h2>
        <p>
          Your use of the Service is at your sole risk. The Service is provided on an &quot;as is&quot; and &quot;as
          available&quot; basis. We shall not be liable for any direct, indirect, incidental, special, consequential or
          exemplary damages resulting from your use of the Service.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="mb-2 text-xl">9. General Conditions</h2>
        <p>
          You must not modify, adapt, or hack the Service. You agree not to reproduce, duplicate, copy, sell, resell or
          exploit any portion of the Service without express written permission. We reserve the right to remove content
          that we determine violates these Terms.
        </p>
      </section>

      <section>
        <h2 className="mb-2 text-xl">10. Contact Us</h2>
        <p>
          If you have any questions about these Terms, please contact us at{' '}
          <a href="mailto:support@gitdigest.ai" className="decoration-golden-500 hover:text-golden-500 underline">
            support@gitdigest.ai
          </a>
          .
        </p>
      </section>
    </LegalPageLayout>
  )
}
